import {CommonMessages} from '../common.messages';

export const PanelReferralPayoutsEditMessages = {
    GetPayoutRequestFailed: {
        key: 'GetPayoutRequestFailed',
        message: 'Error while communication with the server. Unable to get details about the payout request.'
    },
    PayoutRequestNotFound: {
        key: 'PayoutRequestNotFound',
        message: 'Error while communication with the server. Unable to find the payout request.'
    },
    InvalidPayoutRequestData: {
        key: 'InvalidPayoutRequestData',
        message: 'Error while communication with the server. The payout request details are invalid.'
    },
    ApproveFailed: {
        key: 'ApproveFailed',
        message: 'Error while server request. Unable to approve the payout request.'
    },
    ApproveSucceeded: {
        key: 'ApproveSucceeded',
        message: 'Payout request is successfully approved.'
    },
    MarkPaidFailed: {
        key: 'MarkPaidFailed',
        message: 'Error while server request. Unable to mark the payout request as paid.'
    },
    MarkPaidSucceeded: {
        key: 'MarkPaidSucceeded',
        message: 'Payout request is successfully marked as paid.'
    },
    PaymentReferenceRequired: {
        key: 'PaymentReferenceRequired',
        message: 'Payment reference is required.'
    },
    RejectFailed: {
        key: 'RejectFailed',
        message: 'Error while server request. Unable to reject the payout request.'
    },
    RejectSucceeded: {
        key: 'RejectSucceeded',
        message: 'Payout request is successfully rejected.'
    },
    RejectionReasonRequired: {
        key: 'RejectionReasonRequired',
        message: 'Reason is required.'
    },
    CancelApprovalFailed: {
        key: 'CancelApprovalFailed',
        message: 'Error while server request. Unable to cancel the approval of the payout request.'
    },
    CancelApprovalSucceeded: {
        key: 'CancelApprovalSucceeded',
        message: 'The approval of the payout request is successfully cancelled.'
    },
    CancellationReasonRequired: {
        key: 'CancellationReasonRequired',
        message: 'Reason is required.'
    },
    NoTransferConfirmationRequired: {
        key: 'NoTransferConfirmationRequired',
        message: 'Please confirm that no external transfer was executed.'
    },
    ...CommonMessages
};
